import React from "react";
import {Brands} from "@core-ui/utility";
import {useTheme} from "@core-ui/react-stitch";
import {ResponsiveIcon} from "../components/Icon";
import {ColorTheme, IconContainerProps} from "../types";

export const PauseSquareIcon = ({
  colorTheme,
  ...props
}: IconContainerProps): JSX.Element => {
  const theme = useTheme();
  const colortheme: ColorTheme = colorTheme || ColorTheme.dark;
  const isLight = colortheme === ColorTheme.light;

  const AthletaSVG = (isSmall = false): JSX.Element => {
    const bgColor = {fill: isLight ? "#fff" : "#111"};
    const pauseShapeColor = {fill: isLight ? "#111" : "#fff"};

    if (isSmall) {
      return (
        <svg fill="none" viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg">
          <path d="M44 0H0v44h44V0Z" {...bgColor} fillOpacity=".6" />
          <path
            d="M24.5 18H26v8.441h-1.5V18Zm-6 0H20v8.441h-1.5V18Z"
            {...pauseShapeColor}
          />
        </svg>
      );
    }

    return (
      <svg fill="none" viewBox="0 0 61 61" xmlns="http://www.w3.org/2000/svg">
        <path d="M61 0H0v61h61V0Z" {...bgColor} fillOpacity=".6" />
        <path
          d="M33.5 25H35v12h-1.5V25ZM25 25h1.5v12H25V25Z"
          {...pauseShapeColor}
        />
      </svg>
    );
  };

  const OldNavySVG = (
    <svg viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 0h50v50H0z"
        fill={isLight ? theme.color.b1 : "#fff"}
        opacity=".7"
      />
      <path
        d="M20 19h4v13h-4zM27 19h4v13h-4z"
        fill={isLight ? "#fff" : theme.color.b1}
      />
    </svg>
  );

  const brandIconLargeViewBoxSVGs = {
    [Brands.Athleta]: AthletaSVG(),
    [Brands.BananaRepublic]: null,
    [Brands.BananaRepublicFactoryStore]: null,
    [Brands.Gap]: null,
    [Brands.GapFactoryStore]: null,
    [Brands.OldNavy]: OldNavySVG,
    crossBrand: null,
  };

  const brandIconSmallViewBoxSVGs = {
    ...brandIconLargeViewBoxSVGs,
    [Brands.Athleta]: AthletaSVG(true),
  };

  return (
    <ResponsiveIcon
      {...props}
      brandIconLargeViewBoxSVGs={brandIconLargeViewBoxSVGs}
      brandIconSmallViewBoxSVGs={brandIconSmallViewBoxSVGs}
      viewboxBreakpoint={props.brandName === Brands.Athleta ? 45 : 32}
    />
  );
};
